import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicCssService {
  private renderer: Renderer2;
  private styleElements: Map<string, HTMLStyleElement> = new Map();
  private loadedStyleIds: Set<string> = new Set();
  private linkElements: Map<string, HTMLLinkElement> = new Map();

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  injectCss(cssContent: string, styleId: string): void {
    if (!cssContent || !styleId) return;
    if (this.loadedStyleIds.has(styleId)) return;

    const existingElement = document.getElementById(styleId);
    if (existingElement) {
      this.styleElements.set(styleId, existingElement as HTMLStyleElement);
      this.loadedStyleIds.add(styleId);
      return;
    }

    const styleElement = this.renderer.createElement('style');
    styleElement.type = 'text/css';
    styleElement.id = styleId;
    styleElement.textContent = cssContent;
    this.renderer.appendChild(document.head, styleElement);
    this.styleElements.set(styleId, styleElement);
    this.loadedStyleIds.add(styleId);
  }

  loadStylesheetLink(href: string, linkId: string): Promise<void> {
    return new Promise(resolve => {
      if (!href || !linkId) return resolve();

      const existing = document.getElementById(linkId) as HTMLLinkElement | null;
      if (existing) return resolve();

      const linkEl = this.renderer.createElement('link') as HTMLLinkElement;
      linkEl.id = linkId;
      linkEl.rel = 'stylesheet';
      linkEl.href = href;
      linkEl.onload = () => resolve();
      linkEl.onerror = () => resolve();
      this.renderer.appendChild(document.head, linkEl);
    });
  }

  removeStylesheetLink(linkId: string): void {
    const el = this.linkElements.get(linkId) || document.getElementById(linkId);
    if (el && document.head.contains(el)) {
      this.renderer.removeChild(document.head, el);
      this.linkElements.delete(linkId);
    }
  }
}
